import { render, staticRenderFns } from "./Rules-2.vue?vue&type=template&id=576da844&scoped=true&"
import script from "./Rules-2.vue?vue&type=script&lang=js&"
export * from "./Rules-2.vue?vue&type=script&lang=js&"
import style0 from "./Rules-2.vue?vue&type=style&index=0&id=576da844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576da844",
  null
  
)

export default component.exports